<template>
  <div class="skeleton-carousel-wrapper">
    <div class="skeleton-carousel-container">
      <!-- Left hidden cards -->
      <div class="skeleton-card skeleton-left-2">
        <div class="skeleton-circle"></div>
        <div class="skeleton-content">
          <div class="skeleton-line skeleton-line-title"></div>
          <div class="skeleton-line skeleton-line-text"></div>
        </div>
      </div>
      
      <div class="skeleton-card skeleton-left-1">
        <div class="skeleton-circle"></div>
        <div class="skeleton-content">
          <div class="skeleton-line skeleton-line-title"></div>
          <div class="skeleton-line skeleton-line-text"></div>
        </div>
      </div>

      <!-- Center card (main) -->
      <div class="skeleton-card skeleton-center">
        <div class="skeleton-circle"></div>
        <div class="skeleton-content">
          <div class="skeleton-line skeleton-line-title"></div>
          <div class="skeleton-line skeleton-line-text"></div>
        </div>
      </div>

      <!-- Right cards -->
      <div class="skeleton-card skeleton-right-1">
        <div class="skeleton-circle"></div>
        <div class="skeleton-content">
          <div class="skeleton-line skeleton-line-title"></div>
          <div class="skeleton-line skeleton-line-text"></div>
        </div>
      </div>

      <div class="skeleton-card skeleton-right-2">
        <div class="skeleton-circle"></div>
        <div class="skeleton-content">
          <div class="skeleton-line skeleton-line-title"></div>
          <div class="skeleton-line skeleton-line-text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceCardSkeleton',
  props: {
    count: {
      type: Number,
      default: 3
    },
    cardClass: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.skeleton-carousel-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.skeleton-carousel-container {
  width: 100%;
  max-width: 1400px;
  height: 450px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 1500px;
  overflow: hidden;
  margin: 0 auto;
}

.skeleton-card {
  position: absolute;
  background: rgba(248, 249, 250, 0.95);
  border-radius: 24px;
  padding: 20px;
  border: 1px solid rgba(108, 117, 125, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 16px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 300px;
  height: 400px;
  will-change: transform, opacity;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.skeleton-center {
  transform: translateX(0) scale(1.05) translateZ(0);
  z-index: 50;
  opacity: 1;
  animation: pulse 1.5s ease-in-out infinite;
}

/* Left cards - background */
.skeleton-left-1 {
  transform: translateX(-320px) scale(0.85) translateZ(-150px) rotateY(15deg);
  z-index: 40;
  opacity: 0.75;
  animation: pulse 1.5s ease-in-out infinite 0.2s;
}

.skeleton-left-2 {
  transform: translateX(-580px) scale(0.7) translateZ(-250px) rotateY(25deg);
  z-index: 30;
  opacity: 0.5;
  animation: pulse 1.5s ease-in-out infinite 0.4s;
}

/* Right cards - background */
.skeleton-right-1 {
  transform: translateX(320px) scale(0.85) translateZ(-150px) rotateY(-15deg);
  z-index: 40;
  opacity: 0.75;
  animation: pulse 1.5s ease-in-out infinite 0.2s;
}

.skeleton-right-2 {
  transform: translateX(580px) scale(0.7) translateZ(-250px) rotateY(-25deg);
  z-index: 30;
  opacity: 0.5;
  animation: pulse 1.5s ease-in-out infinite 0.4s;
}

.skeleton-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(90deg, #e8e9ea 25%, #d8d9da 50%, #e8e9ea 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-top: 2rem;
}

.skeleton-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.skeleton-line {
  height: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg, #e8e9ea 25%, #d8d9da 50%, #e8e9ea 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-line-title {
  width: 80%;
  margin: 0 auto;
  height: 20px;
}

.skeleton-line-text {
  width: 90%;
  margin: 0 auto;
  height: 12px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
}

@media (max-width: 1200px) {
  .skeleton-carousel-container {
    max-width: 1000px;
  }
}

@media (max-width: 768px) {
  .skeleton-card {
    width: 250px;
    height: 350px;
  }
  
  .skeleton-left-1,
  .skeleton-right-1 {
    transform: translateX(-280px) scale(0.85);
  }
  
  .skeleton-right-1 {
    transform: translateX(280px) scale(0.85);
  }
}
</style>
